import { gql } from '@apollo/client';

export const ParagraphInfoBoxFragment = gql`
  fragment ParagraphInfoBox on ParagraphInfoBox {
    title
    text
    colorSchema
  }
`;
